export const RouteGetMerchantSettings = "/merchant-settings";
export const RoutePutMerchantSettings = RouteGetMerchantSettings;

export type JsonValue =
  | string
  | number
  | boolean
  | null
  | JsonValue[]
  | { [key: string]: JsonValue };

export type CdtStudioConfiguration = {
  profile: JsonValue;
  /** Advanced-editor draft; may be invalid or differ from `profile`. */
  profileJson?: string;
};

/** Keys are trimmed, uppercase category codes. */
export const normalizeCdtStudioCategoryKey = (value: string): string => value.trim().toUpperCase();

export type MerchantSettingsResponse = {
  productRankingEnabled: boolean;
  maxUnitsEnabled: boolean;
  spaceMixEnabled: boolean;
  dosPercentage: boolean;
  jdaImportEnabled: boolean;
  /**
   * Master gate for shelf-weight handling: per-SKU weights on the pogger
   * request, the weight post-processing passes, and the weight surfaces on the
   * planogram screen. Off unless the merchant opts in.
   */
  shelfWeightEnabled: boolean;
  /**
   * Whether the planogram rules modal opens with "leave slow movers out"
   * (`PspRules.range.min_candidate_quantity`) switched on. Off unless the
   * merchant opts in; 7-Eleven Malaysia does.
   */
  excludeSlowMoversByDefault: boolean;
  basePogReportId: string | null;
  storePogReportId: string | null;
  singleStorePogReportId: string | null;
  categoryRangeReviewReportId: string | null;
  cdtStudioConfigurations: Record<string, CdtStudioConfiguration>;
};

export type ResponseGetMerchantSettings = MerchantSettingsResponse;

/** Server ignores this field for pre-DEV-3309 client compatibility. */
export type PayloadPutMerchantSettingsScalars = Partial<
  Omit<MerchantSettingsResponse, "cdtStudioConfigurations">
> & { cdtStudioConfigurations?: never };

export type PayloadPutCdtStudioConfiguration = {
  categoryCode: string;
  configuration: CdtStudioConfiguration;
} & { [K in keyof PayloadPutMerchantSettingsScalars]?: never };

/** Dispatched by the presence of `categoryCode`. */
export type PayloadPutMerchantSettings =
  | PayloadPutMerchantSettingsScalars
  | PayloadPutCdtStudioConfiguration;

export type ResponsePutMerchantSettings = MerchantSettingsResponse;
